import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  Form, FormGroup, Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Table
} from 'reactstrap';
const v = require("voca");
import $ from "jquery";
import { inject, observer } from "mobx-react";
import { MakeForm } from "common-import/custom"

const propStringRequired = [
  "name", "address", "city", "country", "district"
];
const propArrayRequired = [

];
const propString = [
  "status", "investmentType", "minContructionArea", "maxContructionArea", "minLandArea", "maxLandArea", "totalFloorArea", "state", "purpose"
];

@inject("projectStore", "fieldStore") @observer
class Importprojects extends Component {

  constructor(props) {
    super(props);
    this.state = {
      project: {},
      projectSubTypeFilter: "",
      projectStatusFilter: ""
    };
  }

  createproject = async () => {
    let projectData = {...this.form1.getValue(), ...this.form2.getValue()};

    if (!!projectData.constructionArea) {
      if (projectData.constructionArea.includes("Less than") || projectData.constructionArea.includes("Nhỏ hơn")) {
        projectData.minConstructionArea = 0;
        projectData.maxConstructionArea = 100;
        delete projectData.constructionArea;
      } else if (projectData.constructionArea.includes("-")) {
        let [minConstructionArea, maxConstructionArea] = projectData.constructionArea.replace(/,/g, "").split("-");
        projectData.minConstructionArea = +minConstructionArea.trim();
        projectData.maxConstructionArea = +maxConstructionArea.trim();
        delete projectData.constructionArea;
      } else if(!isNaN(projectData.constructionArea)) {
        projectData.minConstructionArea = 0;
        projectData.maxConstructionArea = projectData.constructionArea;
        delete projectData.constructionArea;
      } else {
        return alert('dữ liệu trường Construction Area không đúng');
        // delete projectData.constructionArea;
      }
    }

    if (!!projectData.landArea) {
      if (projectData.landArea.includes("Less than") || projectData.landArea.includes("Nhỏ hơn")) {
        projectData.minLandArea = 0;
        projectData.maxLandArea = 100;
        delete projectData.landArea;
      } else if (projectData.landArea.includes("-")) {
        let [minLandArea, maxLandArea] = projectData.landArea.replace(/,/g, "").split("-");
        projectData.minLandArea = +minLandArea.trim();
        projectData.maxLandArea = +maxLandArea.trim();
        delete projectData.landArea;
      } else if(!isNaN(projectData.landArea)) {
        projectData.minLandArea = 0;
        projectData.maxLandArea = projectData.landArea;
        delete projectData.landArea;
      } else {
        return alert('dữ liệu trường Land Area không đúng');
        // delete projectData.landArea;
      }
    }

    if (!!projectData.budget) {
      if (projectData.budget.includes("Less than") || projectData.budget.includes("Nhỏ hơn")) {
        projectData.minBudget = 0;
        projectData.maxBudget = 1000000000;
        delete projectData.budget;
      } else if (projectData.budget.includes("Greater than") || projectData.budget.includes("Lớn hơn")) {
        projectData.minBudget = 1000000000000;
        projectData.maxBudget = 1000000000000;
        delete projectData.budget;
      } else if (projectData.budget.includes("-")) {
        let [minBudget, maxBudget] = projectData.budget.replace(/,/g, "").split("-");
        projectData.minBudget = +minBudget.trim();
        projectData.maxBudget = +maxBudget.trim();
        delete projectData.budget;
      } else if(!isNaN(projectData.budget)) {
        projectData.minBudget = 0;
        projectData.maxBudget = projectData.budget;
        delete projectData.budget;
      } else {
        return alert('dữ liệu trường Budget không đúng');
      }
    }

    const { projectStore } = this.props;
    let result = await projectStore.create(projectData);
    if (!!result.error) return window.toast.error("Có lỗi xảy ra, vui lòng thử lại   " + JSON.stringify(result.error));
    window.toast.info("Tạo nhà thầu thành công");
    setTimeout(() => {
      this.props.history.push("/projects/list-not-approved");
    }, 500);
  }

  renderMutipleImport = () => {
    return (
      <Row>
        <Col xs="12" md="12">
          <Card>
            <CardHeader>
              <i className="fa fa-envelope-open"></i> Create multiple projects - Upload files (Chưa chạy)
              </CardHeader>
            <CardBody>
              <Form action="" method="post" className="form-horizontal">
                <FormGroup row>
                  <Col md="12">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <Button type="button" color="primary"><i className="fa fa-file"></i> Upload</Button>
                      </InputGroupAddon>
                      <Input type="text" id="input1-group2" name="input1-group2" placeholder="File path .xlsx .csv" />
                    </InputGroup>
                  </Col>
                </FormGroup>
              </Form>
              <CardFooter>
                <Button type="submit" size="sm" color="success"><i className="fa fa-dot-circle-o"></i> Submit</Button>
                <Button type="reset" size="sm" color="danger"><i className="fa fa-ban"></i> Reset</Button>
              </CardFooter>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }

  makeFilterProjectSubType = (projectType) => {
    const { fieldStore } = this.props;
    const { toSelectData, project_type, findID } = fieldStore;
    let id = findID(project_type, projectType);
    let projectSubTypeFilter =  id.split(".")[0] + ".";
    this.setState({ projectSubTypeFilter });
  }

  makeFilterStatus = (projectState) => {
    const { fieldStore } = this.props;
    const { toSelectData, project_state, findID } = fieldStore;
    let id = findID(project_state, projectState);
    let projectStatusFilter =  id.split(".")[0] + ".";
    this.setState({ projectStatusFilter });
  }

  render() {
    const { projectSubTypeFilter, projectStatusFilter } = this.state;
    const { fieldStore } = this.props;
    const { toSelectData, toSelectDataWithFilter, contractor_company_type, project_state, project_state_status, project_work_type,
      project_investment_type, project_purpose, project_construction_area, project_land_area, project_budget, 
      contractor_type, contractor_construction_type, project_type, project_sub_type } = fieldStore
    const importTemp1 = [
      { name: "name", label: "Tên dự án", type: "string", isRequired: true },
      { name: "description", label: "Mô tả", type: "string", isRequired: true },
      { name: "projectType", label: "Project Type", type: "string select", selectData: toSelectData(project_type), isRequired: false, customOnChange: this.makeFilterProjectSubType },
      { name: "projectSubType", label: "Project Sub Type", type: "string select", selectData: toSelectDataWithFilter(projectSubTypeFilter)(project_sub_type), isRequired: false },
      { name: "workType", label: "Work Type", type: "string select", selectData: toSelectData(project_work_type), isRequired: false },
      { name: "address", label: "Địa chỉ", type: "string", isRequired: true },
      { name: "village", label: "Village", type: "string", isRequired: false },
      { name: "city", label: "Thành phố", type: "string", isRequired: true },
      { name: "district", label: "Quận", type: "string", isRequired: true },
      { name: "country", label: "Quốc gia", type: "string", isRequired: true },
      // { name: "minBudget", label: "Min Budget", type: "number", isRequired: false },
      // { name: "maxBudget", label: "Max Budget", type: "number", isRequired: false },
      { name: "budget", label: "Budget", type: "string select", selectData: toSelectData(project_budget), isRequired: false }
    ];
    
    const importTemp2 = [
      { name: "investmentType", label: "Investment Type", type: "string select", selectData: toSelectData(project_investment_type), isRequired: false },
      // { name: "minConstructionArea", label: "Min Construction Area", type: "number", isRequired: false },
      // { name: "maxConstructionArea", label: "Max Construction Area", type: "number", isRequired: false },
      { name: "constructionArea", label: "Construction Area", type: "string select", selectData: toSelectData(project_construction_area), isRequired: false },
      { name: "landArea", label: "Land Area", type: "string select", selectData: toSelectData(project_land_area), isRequired: false },
      // { name: "minLandArea", label: "Min Land Area", type: "number", isRequired: false },
      // { name: "maxLandArea", label: "Max Land Area", type: "number", isRequired: false },
      // { name: "totalFloorArea", label: "Total Floor Area", type: "number", isRequired: false },
      { name: "state", label: "Giai đoạn - State", type: "string select", selectData: toSelectData(project_state), customOnChange: this.makeFilterStatus, isRequired: false },
      { name: "status", label: "Trạng thái - Status", type: "string select", selectData: toSelectDataWithFilter(projectStatusFilter)(project_state_status), isRequired: false },
      { name: "purpose", label: "Purpose", type: "string select", selectData: toSelectData(project_purpose), isRequired: false },
      { dateName: ["minStartTime", "maxStartTime"], label: "Khoảng thời gian bắt đầu", type: "date duration", isRequired: false },
      { dateName: ["minFinishTime", "maxFinishTime"], label: "Khoảng thời gian kết thúc", type: "date duration", isRequired: false },
      { name: "listImages", label: "Hình ảnh", type: "array upload", urlType: "image", isRequired: false }
    ];

    return (
      <div className="animated fadeIn">
        {/* {this.renderMutipleImport()} */}
        <Card>
          <CardHeader>
            <i className="fa fa-envelope-open"></i> Create a project
          </CardHeader>
          <CardBody>
            <Row>
              <Col xs="12" md="6">
                <MakeForm
                  ref={ref => this.form1 = ref}
                  template={importTemp1}
                />
              </Col>
              <Col xs="12" md="6">
                <MakeForm
                  ref={ref => this.form2 = ref}
                  template={importTemp2}
                />
              </Col>
            </Row>
          </CardBody>
          <CardFooter>
            <Button type="submit" size="sm" color="primary" onClick={this.createproject}><i className="fa fa-dot-circle-o"></i> Save</Button>
            <Button type="reset" size="sm" color="danger"><i className="fa fa-ban"></i> Cancel</Button>
          </CardFooter>
        </Card>
      </div>
    );
  }
}

export default Importprojects;


// WEBPACK FOOTER //
// ./src/views/Projects/ImportProject.js